import PageDefault, { ContentMenuItem } from 'components/PageDefault';
// import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory, useRouteMatch } from 'react-router';
import profileService from 'services/profile.service';
import extractFormData from 'utils/extractFormatData';
import useStateByRequest from 'utils/useStateByRequest';
import Permissions from './Permissions';
import ProfileData from './ProfileData';
import { useTranslation } from 'react-i18next';

export default function FormProfile(){
  let match = useRouteMatch<any>();
  const [ data, setData ] = useStateByRequest<any>(profileService,{},);
  
  // const [ dataCompare, setDataCompare ] = useState<any>({});
  const history = useHistory();

  const { t } = useTranslation()

  // function getData(id:number){
  //   profileService.show(id,{params:{
  //     fields:"id,name,profile_type_id",
  //   }}).then(data=>{
  //     setData(data);
  //     // setDataCompare(data);
  //   })
  // }
  
  function submit(){
    let formdata = new FormData();
    extractFormData(data,formdata);
    
    if(match.params && match.params.id){
      profileService.updateLoad(match.params.id,formdata).then((data:any)=>{
        history.push("/admin/profile");
      })
    } else {
      profileService.storeLoad(formdata).then((data:any)=>{
        history.push("/admin/profile");
      })
    }
  }

  if(match.params.id && !data.id) return <></>;

  return (
    <PageDefault title={t("title:profile:form")}>
      <PageDefault.Title>{t("title:profile:form")}</PageDefault.Title>
      <PageDefault.ContentMenu>
        <ContentMenuItem component={ProfileData} title={t("title:profile:data")} props={
          {model:data, setModel:setData}
        }/>
        <ContentMenuItem component={Permissions} title={t("title:profile:permissions")} props={
          {model:data, setModel:setData}
        }/>
      </PageDefault.ContentMenu>
      <PageDefault.Footer>
        <Button onClick={submit}>Save</Button>
      </PageDefault.Footer>
    </PageDefault>
  );
}